export default __webpack_public_path__ + "static/media/turismo.77658b38.gif";